import { Action, combineReducers, configureStore, Reducer } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PersistConfig,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./auth";
import loaderReducer from "./global/loader";
import homeReducer from "./home";
import userReducer from "./user";
import userSettingReducer from "./userSetting";
import { createReduxEnhancer } from "@sentry/react";

const persistConfig: PersistConfig<any, any, any> = {
  key: `root`,
  storage,
  whitelist: ["authState"]
};

const appReducer = combineReducers({
  authState: authReducer,
  userState: userReducer,
  homeState: homeReducer,
  userSettingState: userSettingReducer,
  loaderState: loaderReducer
});

export const rootReducer: Reducer = (state: RootState, action: Action) => {
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sentryEnhancer = createReduxEnhancer({
  actionTransformer: (action) => ({ type: action.type })
});
export const store = configureStore({
  reducer: persistedReducer,
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryEnhancer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
});

export const persistor = persistStore(store, {}, () => {
  persistor.persist();
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
